import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FilesService } from 'src/app/core/services/files.service';
import { ICaseFile } from '../../interfaces/case-file.interface';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'case-files',
  templateUrl: './case-files.component.html',
  styleUrls: ['./case-files.component.scss'],
})
export class CaseFilesComponent implements OnInit {
  @Input() files: ICaseFile[];
  @Output() filesChange = new EventEmitter<ICaseFile[]>();
  @Input() newFiles: ICaseFile[];
  @Output() newFilesChange = new EventEmitter<ICaseFile[]>();
  @Input() deleteFiles: ICaseFile[];
  @Output() deleteFilesChange = new EventEmitter<ICaseFile[]>();
  @Input() isEditing: boolean;

  constructor(
    private readonly filesService: FilesService,
    private userService: UserService
  ) {}

  ngOnInit() {}

  delete(url: string) {
    let index = this.files.findIndex((file) => file.url == url);

    const fileDeleted = this.files.splice(index, 1);
    if (this.isEditing) {
      this.deleteFiles.push(fileDeleted[0]);
      this.deleteFilesChange.emit(this.deleteFiles);

      let indexNews = this.newFiles.findIndex((file) => file.url == url);
      if (indexNews != -1) {
        this.newFiles.splice(indexNews, 1);
        this.newFilesChange.emit(this.newFiles);
      }
    }
  }
  addFile() {
    const input = document.createElement('input');
    input.type = 'file';

    input.click();
    input.onchange = (ev: any) => {
      const file: File = ev.target.files[0];
      const formData = new FormData();
      formData.append('file', file);
      this.filesService.upload(formData).subscribe({
        next: (url) => {
          const newFile = {
            url,
            name: file.name,
            creator: this.userService.currentUser._id,
          };

          this.files.push(newFile);
          this.filesChange.emit(this.files);
          if (this.isEditing) {
            this.newFiles.push(newFile);
            this.newFilesChange.emit(this.newFiles);
          }
        },
      });
    };
  }
}
